// 3rd party libs
import React, { ReactElement, useMemo, useState } from 'react';
import { AddEditGroup } from 'pages/UserManagementTwo/components';
import { Flyout, FlyoutHeader } from 'components';
import styled from 'styled-components';
import { Id } from 'types';
import { GroupItem } from 'types/user-management';
import ConfirmationModal from 'common/components/ConfirmationModal';
import TriangleWarning from 'icons/indexed-icons/TriangleWarning';

const Container = styled.div`
  background: ${({ theme }) => theme.colors.white};
  height: 100%;
  outline: none;
  overflow: auto;
`;

interface Props {
  tableItemId?: Id;
  open: boolean;
  setIsOpenModal: (isOpenModal: boolean) => void;
}

const initialGroupInfo: GroupItem = {
  name: '',
  isInternal: false,
  allOrganizations: false,
  allMachines: false,
  allPlants: false,
  organizations: [],
  plants: [],
  machines: [],
  permissions: [],
  users: []
};

const GroupModal = ({ tableItemId, open, setIsOpenModal }: Props): ReactElement => {
  const [isChanged, setIsChanged] = useState(false);
  const [isViewConfirmCancel, setIsViewConfirmCancel] = useState(false);
  const [groupName, setGroupName] = useState<string>('');
  const onClose = () => {
    setIsOpenModal(false);
    setIsChanged(false)
  };
  const onCloseVerifyData = () => {
    if (isChanged) {
      setIsViewConfirmCancel(true);
    } else {
      setIsChanged(false);
      setIsOpenModal(false);
    }
  };
  const flyoutTitle = useMemo(() => {
    return tableItemId ? `Edit group ${groupName}` : `Add a new group`;
  }, [tableItemId, groupName]);

  const helperText = `Are you sure you want to go back to groups? You have unsaved changes.`;
  const title = 'Unsaved Changes';
  return (
    <>
      {isViewConfirmCancel && (
        <ConfirmationModal
          isConfirmPrompt
          isVisible={isViewConfirmCancel}
          type="warning"
          title={title}
          headerIcon={<TriangleWarning />}
          onCancelCallback={() => {
            setIsViewConfirmCancel(false);
          }}
          onConfirmCallback={() => {
            setIsOpenModal(false);
            setIsViewConfirmCancel(false);
            setIsChanged(false);
          }}
        >
          <p>{helperText}</p>
        </ConfirmationModal>
      )}
      <Flyout width="28.125rem" visible={open} onClose={onCloseVerifyData}>
        <FlyoutHeader heading={flyoutTitle} onClose={onCloseVerifyData} marginLeft="0.625rem" />
        <Container tabIndex={0}>
          <AddEditGroup
            id={tableItemId}
            setIsChanged={setIsChanged}
            initialGroupInfo={initialGroupInfo}
            onCloseVerifyData={onCloseVerifyData}
            onClose={onClose}
            setGroupName={setGroupName}
            groupName={groupName}
            isChanged={isChanged}
          />
        </Container>
      </Flyout>
    </>
  );
};

export default GroupModal;
